"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _deprecate = _interopRequireDefault(require("../../utils/deprecate"));

var _excluded = ["className", "svgRef"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Icon = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2.default)(Icon, _React$PureComponent);

  var _super = _createSuper(Icon);

  function Icon() {
    (0, _classCallCheck2.default)(this, Icon);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(Icon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          svgRef = _this$props.svgRef,
          otherProps = (0, _objectWithoutProperties2.default)(_this$props, _excluded);
      return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        className: (0, _classnames.default)('ui-icon', className),
        ref: svgRef
      }, otherProps), /*#__PURE__*/_react.default.createElement("path", {
        d: "M10.382,4.29262745e-16 C6.56657181,-0.0170044115 3.11737027,2.26826687 1.6454715,5.78839405 C0.173572719,9.30852124 0.969450114,13.3688211 3.66135994,16.0727817 C6.35326978,18.7767423 10.4099743,19.5907477 13.9366408,18.1345867 C17.4633073,16.6784257 19.7639621,13.2394661 19.764,9.424 C19.7695437,4.23336049 15.5726125,0.0176410335 10.382,4.29262745e-16 Z M10.3819708,17.8480519 C6.97091934,17.8650587 3.88629284,15.8233266 2.56923222,12.676755 C1.2521716,9.53018343 1.96267259,5.89992462 4.36878834,3.4820395 C6.7749041,1.06415439 10.4016528,0.335948114 13.5546135,1.63763945 C16.7075742,2.93933079 18.7643334,6.013958 18.7639708,9.42505186 C18.7700658,14.0634726 15.0203661,17.8315137 10.3819708,17.8480519 Z M8.89172918,12.0259058 L5.62472918,8.73990575 L4.91572918,9.44490575 L8.88872918,13.4409058 L15.6447292,6.70790575 L14.9377292,5.99990575 L8.89172918,12.0259058 Z"
      }));
    }
  }]);
  return Icon;
}(_react.default.PureComponent);

Icon.displayName = 'Success3Icon';

var _default = (0, _deprecate.default)({
  message: 'Please use SuccessStrokeIcon. ',
  name: Icon.displayName
})(Icon);

exports.default = _default;
//# sourceMappingURL=Success3.js.map